module.exports = __webpack_public_path__ + "static/media/rose.b33f31fe.png";